module.exports = __webpack_public_path__ + "img/11.45fed53b.jpg";